import styled from "styled-components";

const TabLoading = () => {
  return (
    <Div>
      <div className="app-container">
        <div id="skeleton-screen">
          <div className="header">
            <div className="header-title skeleton"></div>
            <div className="header-title skeleton"></div>
            <div className="header-title skeleton"></div>
            <div className="header-title skeleton"></div>
            <div className="header-title skeleton"></div>
          </div>

          {/* <div className="content">
            <div className="profile">
              <div className="avatar skeleton"></div>
              <div className="profile-info">
                <div className="profile-name skeleton"></div>
                <div className="profile-description skeleton"></div>
              </div>
            </div>

            <div className="media-card">
              <div className="media-image skeleton"></div>
              <div className="media-title skeleton"></div>
              <div className="media-text skeleton"></div>
              <div className="media-text skeleton"></div>
            </div>

            <div className="list-item">
              <div className="list-item-icon skeleton"></div>
              <div className="list-item-content">
                <div className="list-item-title skeleton"></div>
                <div className="list-item-subtitle skeleton"></div>
              </div>
            </div>

            <div className="list-item">
              <div className="list-item-icon skeleton"></div>
              <div className="list-item-content">
                <div className="list-item-title skeleton"></div>
                <div className="list-item-subtitle skeleton"></div>
              </div>
            </div>

            <div className="list-item">
              <div className="list-item-icon skeleton"></div>
              <div className="list-item-content">
                <div className="list-item-title skeleton"></div>
                <div className="list-item-subtitle skeleton"></div>
              </div>
            </div>
          </div> */}

          {/* <div className="bottom-nav">
            <div className="nav-item">
              <div className="nav-icon skeleton"></div>
              <div className="nav-label skeleton"></div>
            </div>
            <div className="nav-item">
              <div className="nav-icon skeleton"></div>
              <div className="nav-label skeleton"></div>
            </div>
            <div className="nav-item">
              <div className="nav-icon skeleton"></div>
              <div className="nav-label skeleton"></div>
            </div>
            <div className="nav-item">
              <div className="nav-icon skeleton"></div>
              <div className="nav-label skeleton"></div>
            </div>
          </div> */}
        </div>

        {/* <div id="real-content" className="real-content">
          <h1>Content Loaded!</h1>
          <p>
            This is the actual content of your application that would replace
            the skeleton screen once your data has loaded.
          </p>
          <button id="reload-btn">Reload Skeleton</button>
        </div> */}
      </div>
    </Div>
  );
};
export default TabLoading;

const Div = styled("div")`
  .app-container {
    height: 100%;
    overflow: hidden;
    position: relative;
  }

  /* Skeleton Components */
  .skeleton {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
  }

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }

  /* Header */
  .header {
    padding: 16px;
    border-bottom: 1px solid #eaeaea;
    display: flex;
    align-items: center;
  }

  .back-button {
    width: 24px;
    height: 24px;
    margin-right: 16px;
  }

  .header-title {
    width: 140px;
    height: 24px;
    margin-right: 15px;
  }

  /* Content */
  .content {
    padding: 16px;
  }

  /* Profile */
  .profile {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }

  .avatar {
    width: 64px;
    height: 64px;
    border-radius: 50%;
  }

  .profile-info {
    margin-left: 16px;
    flex: 1;
  }

  .profile-name {
    width: 120px;
    height: 20px;
    margin-bottom: 8px;
  }

  .profile-description {
    width: 200px;
    height: 14px;
  }

  /* Media Card */
  .media-card {
    margin-bottom: 24px;
  }

  .media-image {
    width: 100%;
    height: 200px;
    border-radius: 8px;
    margin-bottom: 12px;
  }

  .media-title {
    width: 70%;
    height: 18px;
    margin-bottom: 8px;
  }

  .media-text {
    width: 90%;
    height: 14px;
    margin-bottom: 6px;
  }

  /* List Items */
  .list-item {
    display: flex;
    padding: 12px 0;
    border-bottom: 1px solid #eaeaea;
    align-items: center;
  }

  .list-item-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    margin-right: 12px;
  }

  .list-item-content {
    flex: 1;
  }

  .list-item-title {
    width: 60%;
    height: 16px;
    margin-bottom: 6px;
  }

  .list-item-subtitle {
    width: 40%;
    height: 12px;
  }

  /* Bottom Navigation */
  .bottom-nav {
    display: flex;
    justify-content: space-around;
    padding: 12px 8px;
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: white;
    border-top: 1px solid #eaeaea;
  }

  .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .nav-icon {
    width: 24px;
    height: 24px;
    margin-bottom: 4px;
  }

  .nav-label {
    width: 48px;
    height: 12px;
  }

  /* Actual Content (hidden initially) */
  .real-content {
    display: none;
    padding: 16px;
  }

  /* Control */
  .controls {
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 100;
    padding: 8px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;
